const BASE = '/v1/users';

export default (instance) => ({
  /**
   * Upsert the current user's local profile (name/email) and grant them
   * default permissions. Called once per session after login so users
   * invited to an org actually show up in operator/station assignment lists.
   * @param {{ email: string, displayName: string }} data
   */
  syncProfile: (data) => instance.post(`${BASE}/sync-profile`, data),

  /**
   * Unassign the current user from all stations in their current org.
   * Call right after leaving that org, before the access token is refreshed.
   */
  leaveOrg: () => instance.post(`${BASE}/leave-org`)
});
